import { styled } from "@mui/material";
import CarouselV2 from "../CarouselV2";
import { SectionSource } from "interfaces/web-store/section-source";

export const Content = styled("div")`
	display: flex;
	flex-wrap: wrap;
	box-sizing: border-box;
	justify-content: left;
`;

const SectionContent = ({
	items,
	from
}: {
	items: JSX.Element[];
	from?: SectionSource;
}) => <CarouselV2 from={from}>{items}</CarouselV2>;

export default SectionContent;
